module.exports = __webpack_public_path__ + "img/logo_xianlin.092cc81.png";